<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <div :class="item.id == searchtype ? 'mall-goods-show-spu mall-goods-show-spu-on' : 'mall-goods-show-spu'"
        v-for="item in searchtypelists" :key="item.id" @click="changesearchtypes(item.id)">
        {{ item.name }}
      </div>
      <MakeinventoryLocation v-if="searchtype == 1" />
      <MakeinventoryGoods v-if="searchtype == 2" @listenchild="handleEmit" />
    </div>
  </transition>
</template>

<script>
import MakeinventoryGoods from './Makeinventory-goods.vue';
import MakeinventoryLocation from './Makeinventory-location.vue';
export default {
  components: {
    MakeinventoryGoods,
    MakeinventoryLocation
  },
  data() {
    return {
      storageLocationStatus: false,
      transitionshow: true,
      searchtype: 2,
      searchtypelists: [],
    }
  },
  created() {
    // 获取库位开关
    this.storageLocationStatus = localStorage.getItem("storageLocationStatus") == 'true'
    if (this.storageLocationStatus) {
      this.searchtypelists = [{ id: 1, name: '货位盘点' }, { id: 2, name: '货品盘点' }]
      this.searchtype = 1;
    } else {
      this.searchtypelists = [{ id: 2, name: '货品盘点' }]
      this.searchtype = 2;
    }
  },
  methods: {
    changesearchtypes(id) {
      this.searchtype = id;
    },
    handleEmit(data) {
      this.$emit('listenchild', data);
    }
  },
}

</script>

<style scoped>
.mall-goods-show-spu {
  display: inline-block;
  transition: all .5s;
  color: #999999;
  background-color: #cccccc;
  padding: 5px 20px;
  margin-left: 10px;
  font-size: 13px;
  border-radius: 15px 15px 0 0;
  cursor: pointer
}

.mall-goods-show-spu-on,
.mall-goods-show-spu:hover {
  background-color: #fff;
  color: #333336
}
</style>


// WEBPACK FOOTER //
// src/components/home/Makeinventory.vue